import { FormInstance } from 'antd';
import { ProductPayload } from 'types';

export const initializeFormData = (form: FormInstance, data: ProductPayload) => {
  if (!data) return;
  form.setFieldsValue({
    isPublishing: data.isPublishing,
    isActive: data.isActive,
    code: data.product?.code,
    barcode: data.product?.barcode || '',
    name: data.name,
    category: data.categoryId,
    dimension: data.dimension,
    color: data.color,
    sizeSpec: data.sizeSpec,
    baseUnitId: data.baseUnitId,
    statusId: data.statusId,
    costPrice: data.costPrice,
    salePrice: data.salePrice,
    describeProduct: data.description,
    brand: data.brandId,
    currencyUnitId: data.currencyUnitId,
    min: data.minQuantity,
    max: data.maxQuantity,
    productAttributes: data.productAttributes,
    productUnits: data.productUnits,
    density: data.density,
    productSalePrices: data.productSalePrices,
    productSuppliers:
      data.product?.productSuppliers?.map((item) => ({
        supplierId: item.supplierId,
      })) ?? [],
    productImages: data?.productImages?.map((item) => item.image) ?? [],
    version: data.version,
    listVersion: data.product?.productVersions,
    status: data.status?.name,
    quantity: data.product?.quantity || 0,
  });
};
